import { createContext } from 'react';

import { TenantAccessIndicatorState } from '../states/tenant-access-indicator-states';

const TenantAccessIndicatorProviderContext = createContext({} as TenantAccessIndicatorState);

export default TenantAccessIndicatorProviderContext;
